module.exports = __webpack_public_path__ + "static/media/ic-close.32c29963.svg";